import React from 'react'
import TableHeader from '../../../../components/table/TableHeader'
import Text from '../../../../components/text/Text'
import TableLayout from '../../../../components/table/TableLayout'
import WizImage from '../../../../components/image/WizImage'
import {useImage} from '../../../../utils/image'
import {useTime} from '../../../../utils/time'
import useNavigation from '../../../../hooks/useNavigation'
import WizButton from '../../../../components/button/WizButton'
import {ICommentList} from '../../../../apis/comment/getCommentList'
import WizTag from '../../../../components/tag/WizTag'
import CheckTableItem from '../../../../components/table/CheckTableItem'

interface IProps {
    className?: string
    data?: ICommentList[]
    onChecked?: (e?: any) => void
    checkList?: any[]
}

const CommentListTable: React.FC<IProps> = ({className, data, onChecked, checkList}) => {
    const {renderThumbnail} = useImage()
    const {localTimeString} = useTime()
    const {goCommentDetail, goUserDetail} = useNavigation()

    const checkScamComment = (list: ICommentList) => {
        if (!list?.user.name.match('League of Traders') && list?.content.match('http')) {
            return true
        }
    }

    return (
        <div className={`${className}`}>
            <TableHeader
                className={
                    'grid-cols-[300px_auto_200px_250px] lg:grid-cols-[280px_1fr_100px_190px] lg:!gap-x-[10px] md:hidden  pl-[40px] pr-[30px]'
                }>
                <Text>Writer</Text>
                <Text>Comment</Text>
                <Text className={'text-center'}>Links</Text>
                <Text>Create At</Text>
            </TableHeader>
            <TableLayout>
                {data?.map(list => (
                    <CheckTableItem
                        onClick={() => goCommentDetail(list?.id)}
                        key={list?.id}
                        checked={checkList?.find(item => item?.id === list?.id)}
                        onChecked={() => onChecked(list)}
                        className={
                            'grid-cols-[300px_auto_200px_250px] lg:grid-cols-[280px_1fr_100px_190px] !gap-x-[12px] lg:!gap-x-[10px] md:block'
                        }>
                        <div
                            className={'flex space-x-[10px] items-center'}
                            onClick={e => {
                                e.stopPropagation()
                                goUserDetail(list?.user?.id)
                            }}>
                            <div
                                className={
                                    list?.user?.is_filtered && 'border-[2px] border-font_red rounded-full flex-none'
                                }>
                                <WizImage
                                    src={renderThumbnail(list?.user.thumbnail)}
                                    className={'w-[36px] h-[36px] rounded-full'}
                                />
                            </div>
                            <div className={'truncate'}>
                                <Text className={`text-ti2 ${list?.user?.is_filtered && 'text-font_red'} truncate`}>
                                    {list?.user.name}
                                </Text>
                                <Text className={'text-body3 text-font03 hidden md:block '}>
                                    {localTimeString(list?.created_at)}
                                </Text>
                            </div>
                            {list?.user?.is_filtered && (
                                <div className={'bg-shadow_ban px-[5px] py-[1px] rounded-[3px]'}>
                                    <Text className={'text-ti3 text-white'}>Ban</Text>
                                </div>
                            )}
                        </div>
                        <div
                            className={
                                'space-y-[10px] truncate flex space-x-[5px] items-end md:mt-[20px] md:pl-[46px]'
                            }>
                            <Text
                                className={`truncate max-w-[85%] lg:max-w-[100%] text-body2 ${
                                    checkScamComment(list) ? 'text-font_red' : 'text-font02'
                                }`}>
                                {list?.content}
                            </Text>
                            {checkScamComment(list) && <WizTag state={false}>Scam</WizTag>}
                        </div>
                        <div className={'text-center md:mt-[20px] md:text-left md:ml-[46px]'}>
                            <WizButton
                                size={'small'}
                                type={'primary'}
                                text={'Link'}
                                onClick={e => {
                                    window.open(`https://leagueoftraders.io/ko/post/${list?.parent_id}`)
                                    e.stopPropagation()
                                }}
                            />
                        </div>
                        <div className={'md:hidden'}>
                            <Text className={'text-body2 text-font02'}>{localTimeString(list?.created_at)}</Text>
                        </div>
                    </CheckTableItem>
                ))}
            </TableLayout>
        </div>
    )
}

export default CommentListTable
